import { richTextResolver } from "@website-builder/utilities-index";

export default (
	{ heading = "", description = {}, mentorCount = 4, selectedCourses = [] },
	{ mentorProfilesData = [], globalVariableWithURL = [] },
) => {
	return {
		heading,
		description: richTextResolver(description, globalVariableWithURL),
		mentorCount,
		list: buildMentorProfiles(
			mentorProfilesData,
			selectedCourses?.value,
			mentorCount,
		),
		selectedCourses: selectedCourses?.value,
	};
};

export const buildMentorProfiles = (
	mentorProfilesQueryData,
	selectedCourses,
	mentorCount,
) => {
	if (!mentorProfilesQueryData.length || !selectedCourses.length) return [];
	const selectedDatasourceEntries = selectedCourses
		.map((selectedId) =>
			mentorProfilesQueryData.find((element) => element.id == selectedId),
		)
		.filter((element) => !!element)
		.map((mentorListByCourse) => {
			return {
				id: mentorListByCourse?.id,
				name: mentorListByCourse?.name,
				mentorList: JSON.parse(mentorListByCourse?.value)?.data,
			};
		});

	var list = []; // Stores the final mentor-list to display
	var nthMentorOfCourse = 0; // Index variable
	var flag = false; // set to true when we've pushed the required number of mentors into the list

	// Example of what's happening here-
	// We have mentorCount=4 from 3 selected courses (say, A, B, C are the courses and A has mentors 1A, 2A, 3A...)
	// Then, the mentor list will be [ 1A - 1B - 1C - 2A ] (ordered in a cyclic fashion)
	while (true) {
		for (
			let courseNo = 0;
			courseNo < selectedDatasourceEntries.length;
			courseNo++
		) {
			const mentorsOfParticularCourse =
				selectedDatasourceEntries[courseNo].mentorList;
			if (mentorsOfParticularCourse?.length > nthMentorOfCourse) {
				list.push(mentorsOfParticularCourse[nthMentorOfCourse]);
			}
			if (list.length >= mentorCount) {
				flag = true;
				break;
			}
		}
		if (flag) break;
		nthMentorOfCourse++;
	}

	const finalMentorList = list.map((mentor) => {
		return {
			profileImage: {
				image: {
					image: mentor?.avatar,
					alt: mentor?.avatarAltText,
				},
			},
			companyLogo: {
				image: {
					image: mentor?.company,
					alt: mentor?.logoAltText,
				},
			},
			position: mentor?.designation,
			name: mentor?.name,
		};
	});
	return finalMentorList;
};
